/**
 * @param {unknown} raw — parsed JSON from server
 * @returns {raw is { type: string }}
 */
export function isInboundFrame(raw) {
  return Boolean(
    raw && typeof raw === 'object' && typeof raw.type === 'string',
  );
}

/**
 * @param {string} data — WebSocket message data
 * @returns {object | null}
 */
export function parseInboundJson(data) {
  try {
    const o = JSON.parse(data);
    return isInboundFrame(o) ? o : null;
  } catch {
    return null;
  }
}

function randomRequestId() {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

/**
 * @param {{
 *   requestId: string,
 *   message: string,
 *   conversationId?: string,
 *   settings: object,
 * }} p
 * @returns {string}
 */
export function buildChatOutboundPayload(p) {
  return JSON.stringify({
    type: 'chat',
    requestId: p.requestId,
    message: p.message,
    ...(p.conversationId ? { conversationId: p.conversationId } : {}),
    settings: p.settings,
  });
}

/**
 * @param {string} requestId
 * @returns {string}
 */
export function buildCancelOutboundPayload(requestId) {
  return JSON.stringify({ type: 'cancel', requestId });
}

export { randomRequestId };
